/*
* 点位采集管理组件
* zxw
* 创建时间：2025-05-20
* 修改时间：2026-06-30
*/

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import { message, Table, Input, Select, Button, Space, } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    ShowIPModal,
    GetButtonActionName,
} from '../../incs/FunHelper.js';

import Entity from './CollectEntity.js';
import PLCSummary from './PLCSummary.js';

const MODULENAME = CNF.navItems[0].submenu[0].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[0].submenu[0].ptn;
const MODULENAME_URL = CNF.navItems[0].submenu[0].url;

const Lists = (props) => {
    const { btnLists, preGroup, dataLists, currentIndex, pageCount, changeIndex, setOpen, refresh } = props;

    const [openPLCSummary, setOpenPLCSummary] = useState(false);
    const [record, setRecord] = useState(null);

    const update = useCallback((record) => {
        setOpen(true, record);
    }, [setOpen]);

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = useCallback((action, record) => {
        const uri = MODULENAME_URL.slice(1) + '/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.rolename, action, MODULENAME, refresh, uri);
                break;
            default:
                break;
        }
    }, [update, refresh]);

    const hasOpPerm = (
        btnLists.includes(MODULENAME_PTN + '_update') ||
        btnLists.includes(MODULENAME_PTN + '_disable') ||
        btnLists.includes(MODULENAME_PTN + '_active') ||
        btnLists.includes(MODULENAME_PTN + '_delete')
    );

    const columns = useMemo(() => [
        { title: '', width: 20, dataIndex: '', key: 'key', fixed: 'left', },
        {
            title: '编码', key: 'number',
            render: (record) => <Button
                color='primary'
                variant='link'
                style={{ padding: '0 5px', border: 0, height: 22 }}
                onClick={() => {
                    setRecord(record);
                    setOpenPLCSummary(true);
                }}>{record.number}</Button>

        },
        { title: '名称', dataIndex: 'name', key: 'name', },
        { title: '所属单位', dataIndex: 'affiliate_unit', key: 'affiliate_unit', },
        { title: '开始日期', dataIndex: 'start_date', key: 'start_date', },
        // { title: '描述', dataIndex: 'description', key: 'description', },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        { title: '状态', key: 'status', dataIndex: 'status', width: CNF.tableStatusColumnWidth, },
        {
            title: '操作', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: !hasOpPerm,
            render: (record) => GetButtonActionName(btnLists, MODULENAME_PTN, record, operation)
        }
    ], [btnLists, hasOpPerm, operation]);

    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={dataLists}
                pagination={{
                    showSizeChanger: false,
                    showQuickJumper: false,
                    showTotal: () => `共${pageCount > 10000 ? (pageCount / 10000).toFixed(CNF.DPL) + '万' : pageCount}条`,
                    pageSize: CNF.pageSize,
                    current: currentIndex,
                    total: pageCount,
                    onShowSizeChange: (current, pageSize) => props?.changePageSize(pageSize, current),
                    onChange: (current) => changeIndex(current),
                }}
            />
            {
                record && <PLCSummary
                    preGroup={preGroup}
                    btnLists={btnLists}
                    open={openPLCSummary}
                    setOpen={setOpenPLCSummary}
                    record={record}
                />
            }
        </>
    );
}

const PointLocationCollect = (props) => {
    const { btnLists, preGroup } = props;

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [status, setStatus] = useState(CNF.status[0].value);
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);
    const [open, setOpen] = useState(false);
    const [record, setRecord] = useState(null);

    const [number, setNumber] = useState('');
    const [name, setName] = useState('');


    const refresh = useCallback(() => {
        setTriggerRefresh((prev) => prev + 1);
    }, []);

    const handleStatusChange = useCallback((value) => {
        setStatus(value || '');
        setCurrentIndex(1);
    }, []);

    const changeIndex = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    const handleNumberChange = useCallback((e) => {
        setNumber(e.target.value);
        setCurrentIndex(1);
    }, []);

    const handleNameChange = useCallback((e) => {
        setName(e.target.value);
        setCurrentIndex(1);
    }, []);

    const setOpenModal = useCallback((value, recordData) => {
        setOpen(value);
        setRecord(recordData || null);
    }, []);

    const create = useCallback(() => {
        setOpenModal(true, null);
    }, [setOpenModal]);

    useEffect(() => {
        setLoading(true);

        const params = {
            number,
            name,
            status,
            page_size: CNF.pageSize,
            current_index: currentIndex,
        };

        $.ajax({
            url: `${CNF.api}pointLocations/collects${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
            success: (data) => {
                if (data.res === 0) {
                    setDataLists(data.dat || []);
                    setPageCount(data.cnt || 0);
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            },
            error: (err) => {
                messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
            },
            complete: () => {
                setLoading(false);
            },
        });
    }, [number, name, status, currentIndex, triggerRefresh, messageApi]);

    return (
        <>
            {contextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                <Input
                    onChange={handleNumberChange}
                    placeholder='编码'
                    value={number}
                />
                <Input
                    onChange={handleNameChange}
                    placeholder='名称'
                    value={name}
                />
                <Select
                    allowClear
                    placeholder='状态'
                    style={{ width: '100%' }}
                    onChange={handleStatusChange}
                    options={CNF.status.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.key,
                    }))}
                    value={status || undefined}
                />
                {btnLists.includes(MODULENAME_PTN + '_create') && (
                    <Button
                        title={CNF.actionName.CREATE + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<PlusOutlined />}
                        onClick={create}
                    >
                        {CNF.actionName.CREATE}
                    </Button>
                )}

            </Space>
            <Lists
                btnLists={btnLists}
                preGroup={preGroup}
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={changeIndex}
                setOpen={setOpenModal}
                refresh={refresh}
                loading={loading}
            />
            <Entity
                preGroup={preGroup}
                open={open}
                record={record}
                setOpen={setOpenModal}
                refresh={refresh}
            />
        </>
    );
};

export default PointLocationCollect;